module.exports = __webpack_public_path__ + "assets/svg/Icons/32/labor-gray-59b2d0.svg";